import { render } from "./NavegacionMenu.vue?vue&type=template&id=0f727b8c"
import script from "./NavegacionMenu.vue?vue&type=script&lang=js"
export * from "./NavegacionMenu.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__